export default "__VITE_ASSET__BuhRbwxn__"